export class PassedPatientCaseWorkItemEventModel {
  CaseWorkItemID: string;
  WorkItemEventID: string;
  ProviderDoctorContactID: string;
  LOCID: number;
  StartTimer: boolean;
  StopTimer: boolean;
  ProviderDoctorID: string;
}
